import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Injector, Input, isDevMode, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, debounceTime, exhaustMap, Observable, of, ReplaySubject, scan, startWith, Subject, switchMap, tap } from 'rxjs';
import { takeWhileInclusive } from 'rxjs-take-while-inclusive';
import { KeyValue } from 'src/app/models/key-value';
import { MasterCommon } from 'src/app/models/masters/master-common';
import { DocumentService } from 'src/app/services/api/document.service';
import { MasterService } from 'src/app/services/api/masters.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { documentTypes } from '../document-create-update/types-factory/document-types';
import { ExpedientFilters } from 'src/app/models/expedients/expedient-filters';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/utils/storage.service';
import { CommonService } from 'src/app/services/api/common.service';
import { Purchase } from 'src/app/models/expedients/purchase';

@Component({
  selector: 'vex-crv-create',
  templateUrl: './crv-create.component.html',
  styleUrls: ['./crv-create.component.scss']
})

export class CrvCreateComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
    private router: Router,
    private dialogRef: MatDialogRef<CrvCreateComponent>,
    private fb: FormBuilder,
    private injector: Injector,
    private alert: ToastService,
    private commonService: CommonService<Purchase, ExpedientFilters>,
    private masterService: MasterService<MasterCommon>,
    public scroll: ScrollDispatcher,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService) {}

  next$ = new Subject();
  startSearch = new BehaviorSubject<any>('');
  startSearch$ = this.startSearch.asObservable();
  expedientFilters: ExpedientFilters = new ExpedientFilters();
  expFilters: ExpedientFilters = new ExpedientFilters();
  service: any;
  filters: ExpedientFilters;
  
  officeId: number;
  
  pageSize = 10;
  pageIndex = 0;
  order = "desc";
  orderType = "";

  CRVservice: string = "documents/crv";
  
  form: FormGroup;
  receiver: Array<any>;
  vehicles: Array<any>;
  CRVdata: any;
  documentType: string;
  filteredOptions: Observable<KeyValue[]>;
  entityReceiver: string = "client";

  crvId: number = null;
  sending: boolean = false;
  /** EEC-082: petición de generar en vuelo; bloquea los botones para evitar el doble clic. */
  saving: boolean = false;
  isSigned: boolean = false;
  hasTract: boolean = true;

  ngOnInit() {

    this.CRVdata = this.defaults.CRVdata;
    this.documentType = this.defaults.documentType;
    this.receiver = this.CRVdata?.client ? this.CRVdata?.client : [];

    this.loadForm();

    this.storageService.getItem("origin").subscribe(origin => {
      this.officeId = origin;
    });

    if (this.documentType == "") {
      this.loadTypeOptions();
      this.loadExpedient();
    }
  }

  loadForm() {
    this.form = this.fb.group({
      driverName: [null],
      truckPlate: [null, ],
      userReceiver: [this.CRVdata?.user.email || null, Validators.required],
      entityReceiver: [this.receiver.length > 0 ? this.receiver[0].email : [], Validators.required],
      entityTransport: [this.CRVdata?.transport.length == 1 ? this.CRVdata?.transport[0] : []],
      loadingLocation: [this.CRVdata?.loadingLocations[0] || []],
      unloadingLocation: [this.CRVdata?.unloadingLocations[0] || []],
      cmr: [[], Validators.required],
      loadingDate: [null],
      unloadingDate: [null],
      sendBroker: false,
      referenceName: this.CRVdata?.referenceName || '',
    });
  }

  save(preview: boolean) {

    if (this.saving) {
      return;
    }
    this.saving = true;

    let item = this.form.value;
    item.adminFileId = this.CRVdata.adminFileId;
    item.preview = preview;
    item.hasTract = this.hasTract;

    this.commonService.create(this.CRVservice, item).subscribe({
      next: response => {
        this.saving = false;
        if (!response) {
          this.sending = false;
          this.alert.error("No ha sido posible generar el CRV");
        } else if (!response.isSuccessful) {
          this.sending = false;
          this.alert.info(response.message);
        } else {
          if (preview) {

            var pdfResult = response.base64;
            var file = this.base64toBlob(pdfResult, response.mimeType);
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');

          } else {
            this.crvId = response.data[0].id;
            this.alert.info("Documento generado");
            if (!this.sending) {
              this.dialogRef.close(response);
            } else {
              this.sendingCRV();
            }

          }
        }
      },
      error: e => {
        this.saving = false;
        this.sending = false;
        this.alert.error("No ha sido posible generar el CRV");
      }
    });
  }

  send() {
    if (this.saving) {
      return;
    }
    this.sending = true;
    this.save(false);
  }

  sendingCRV() {

    let item: any = {
      id: this.crvId,
    };
  
    this.commonService.any(this.CRVservice+"/send", item).subscribe({
      next:
        response => {
          if (!response) {
            this.alert.error("No ha sido posible enviar el CRV");
          }
          else if (!response.isSuccessful) {
            this.alert.info(response.message);
          }
          else {
            this.alert.info("CRV enviado")
            this.sending = false;
            this.dialogRef.close(response);
          }
        },
      error:
        (e) => {
          if (e.status == '401') {
            this.router.navigate(['/login']);
            this.alert.info("Sesión expirada")
            return;
          }
          if (isDevMode)
            this.alert.error(e.message)
          else
            this.alert.error("No ha sido posible enviar el CRV");
        }
    })
  }

  onCheckboxChange(): void {

    this.entityReceiver = this.entityReceiver == "client" ? "brokers" : "client";

    if (this.entityReceiver == 'client') {
      this.receiver = this.CRVdata?.client;
    } else {
      this.receiver = this.CRVdata?.brokers;
    }
    this.form.get("entityReceiver").setValue(null);
  }

  loadExpedient() {
    this.filteredOptions.subscribe(x => {
      const items = x.filter(z => z.name == this.form.value.referenceName.trim());
      this.expedientFilters.administrativeFileId = items[0]?.id;
      this.expedientFilters.pageNumber = 0;
      this.expedientFilters.rowsPerPage = 5;
      this.expedientFilters.order = "asc";
      this.expedientFilters.orderBy = "name";
    });
  }

  loadTypeOptions() {
    this.filteredOptions = this.startSearch$.pipe(
      startWith(''),
      debounceTime(200),
      switchMap(filter => {
        //Note: Reset the page with every new seach text
        let currentPage = 1;
        return this.next$.pipe(
          startWith(currentPage),
          exhaustMap(_ => this.getEntities(currentPage)),
          tap(() => currentPage++),
          takeWhileInclusive((p: any) => p.length > 0),
          scan((allItems: any, newItems: any) => {
            const result = allItems.concat(newItems);
            if (newItems.length == 1) {
              this.filters.referenceId = newItems[0].id;
              this.refreshForm();
            }
            return result;
          }, [])
        );
      })
    );
  }

  getReferenceId(referenceName) {
    this.filteredOptions.subscribe(x => {
      const items = x.filter(z => z.name == referenceName);
      return items[0].id;
    });
  }

  SearchWeightuggestions(val: any) {
    this.getEntities(1);
    this.startSearch.next(val.trim());
    this.cdr.detectChanges();
  }

  getEntities(page: number): Observable<any[]> {
    const injectable = documentTypes.get(3);
    this.service = this.injector.get(injectable);
    this.service.getFilters().subscribe((filters) => {
      this.filters = filters;
    })
    if (this.filters) {
      this.filters.pageNumber = page;
      this.filters.rowsPerPage = 6;
      this.filters.order = "asc";
      this.filters.orderBy = "name";
      this.filters.officeId = this.officeId;
      this.filters.name = this.form.get('referenceName').value.trim();
      return this.masterService.getAllFiltered("administrative-files/maestra", this.filters);
    }
  }

  loadFilters() {
    this.expFilters.pageNumber = this.pageIndex + 1;
    this.expFilters.rowsPerPage = this.pageSize;
    this.expFilters.order = this.order;
    this.expFilters.orderBy = this.orderType;
    this.expFilters.id = this.defaults.values.referenceId;
    this.storageService.getItem("origin").subscribe(origin => {
      if (this.expFilters.officeId != origin) {
        this.expFilters.officeId = origin;
        //this.loadData();
      }
    })
    this.expFilters.orderTypeId = 1;
  }

  refreshForm() {
    this.commonService.getAll(this.CRVservice, this.filters).subscribe({
      next:
        response => {
          if (!response) {
            this.alert.error("No hay documentos");
          }
          else if (!response.isSuccessful) {
            this.alert.info(response.message);
          }
          else {
            this.CRVdata = response.data;
            this.CRVdata.referenceName = this.form.get('referenceName').value;
            this.CRVdata.adminFileId =  this.filters.referenceId;
            this.receiver = this.CRVdata?.client;
            this.loadForm();
          }
        },
      error:
        (e) => {
          if (e.status == '401') {
            this.router.navigate(['/login']);
            this.alert.info("Sesión expirada")
            return;
          }
          if (isDevMode)
            this.alert.error(e.message)
          else
            this.alert.error("No ha sido posible recuperar la lista de documentos");
        }
    })
  }

  areAllFieldsFilled(): boolean {
    const controls = this.form.controls;

    for (const key in controls) {
      if (key === 'sendBroker') continue;

      const value = controls[key].value;

      const isEmpty = value == null || value == undefined ||
        (typeof value === 'string' && value.trim() === '') ||
        (Array.isArray(value) && value.length === 0);

      if (isEmpty) {
        return false;
      }
    }

    return true;
  }

  hasVehicles() {
    
    if (this.form.get('cmr').value != null) {
      if (this.form.get('cmr').value.vehicles?.length > 0) return true;
    }
    
    return false;
  }

  /**
   * EEC-081: sin tramo, los datos del transporte se escriben a mano y
   * `documents_crv` no admite nulos en ellos. Con tramo vienen del CMR y los
   * campos ni se muestran, así que no se exigen.
   */
  private static readonly TRACT_FIELDS = ['driverName', 'truckPlate', 'entityTransport', 'loadingLocation', 'unloadingLocation', 'loadingDate', 'unloadingDate'];

  applyTractValidators() {
    for (const name of CrvCreateComponent.TRACT_FIELDS) {
      const control = this.form.get(name);
      if (this.hasTract === false) {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity();
    }
  }

  onCMRChange(event) {

    this.hasTract = event.hasTract;
    this.applyTractValidators();

    if (event.hasCRV == true) {

      if (event.isSigned) {

        this.isSigned = true;
        this.alert.error("Este CMR ya tiene un CRV firmado");
        this.form.get('cmr').setValue([]);

      } else {
        this.isSigned = false;
        this.alert.info("Este CMR ya tiene un CRV asociado. Si genera un nuevo CRV, se sustituirá el existente.");
      }
    
    } else {
      this.isSigned = false;
    }    
  }

  base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  onContactChange(contact) {
    this.form.get('entityReceiver').setValue(contact);
  }

  isValid() {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(this.form.get('entityReceiver').value);
  }

}


